import hrms15eLabels from 'assets/labels/hrms15e'
import moment from 'moment'
import faker from 'faker'
import labels from 'src/../config/label.js'

export const mocker = {
  labels () {
    return {
      labels: hrms15eLabels
    }
  },
  index () {
    let mockRows = []
    let flgappr = ''
    const mockFlgappr = [ 'P', 'C' ]
    const mockStatus = {
      'P': 'In Process',
      'C': 'Completed'
    }
    const mockTotal = 5
    for (var i = 1; i <= mockTotal; i++) {
      flgappr = mockFlgappr[Math.floor(Math.random() * 2)]
      mockRows.push({
        seqno: i,
        codempid: faker.lorem.word(),
        desc_codempid: faker.name.findName(),
        qtyapp: '1',
        qtybeh: '100.00',
        avgbeh: '0.00',
        qtycmp: '100.00',
        avgcmp: '0.00',
        qtykpi: '100.00',
        avgkpi: '0.00',
        qtytot: '0.00',
        status: mockStatus[flgappr],
        codcomp: faker.random.word(),
        flgtypap: '',
        numseq: i,
        codcomlvl: '',
        codaplvl: '55',
        dteapman: moment(faker.date.past()).format('DD/MM/YYYY'),
        dteapstr: moment(faker.date.past()).format('DD/MM/YYYY'),
        dteapend: moment(faker.date.past()).format('DD/MM/YYYY'),
        flgappr: flgappr,
        codform: faker.random.word(),
        codpos: faker.random.word(),
        numlvl: faker.random.number()
      })
    }

    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  detail () {
    let mockTab1 = {
      dteapman: moment(faker.date.past()).format('DD/MM/YYYY'),
      dteapstr: moment(faker.date.past()).format('DD/MM/YYYY'),
      dteapend: moment(faker.date.past()).format('DD/MM/YYYY'),
      codform: faker.random.word(),
      desform: faker.random.words(),
      commboss: faker.random.words(),
      commemp: faker.random.words(),
      v_qtydabs: Math.floor(Math.random() * 1) + 1,
      v_qtydleav: Math.floor(Math.random() * 1) + 1,
      v_qtydpuns: Math.floor(Math.random() * 1) + 1
    }
    let mockTab1Table1GroupRows = []
    const mockTab1Table1Total = 2
    for (var a = 1; a <= mockTab1Table1Total; a++) {
      let mockTab1Table1ItemRows = []
      const mockTab1Table1ItemTotal = 3
      let mockGroupQtyfscor = 0
      let mockGroupQtyscor = 0
      for (var e = 1; e <= mockTab1Table1ItemTotal; e++) {
        let mockItemQtywgt = Math.floor(Math.random() * 5) + 1
        let mockItemQtyfscor = 4 * mockItemQtywgt
        let mockItemGraditem = Math.floor(mockItemQtyfscor * Math.random())
        let mockItemQtyscor = mockItemGraditem * mockItemQtywgt
        let mockTab1Table2Rows = []
        const mockChoice = [ 'A', 'B', 'C', 'D' ]
        const mockDescChoice = [ 'Excellence', 'Good', 'Normal', 'Bad' ]
        const mockScore = [ '4', '3', '2', '1' ]
        const mockTab1Table2Total = 4
        for (var d = 1; d <= mockTab1Table2Total; d++) {
          mockTab1Table2Rows.push({
            grditem: d,
            grad: mockChoice[d - 1],
            qtyscor: mockScore[d - 1],
            desc_grditem: mockDescChoice[d - 1],
            definit: faker.random.words()
          })
        }
        let mockChoiceFiltered = mockTab1Table2Rows.filter((choice) => {
          return choice.grditem === mockItemGraditem
        })
        let mockGrad = ''
        if (mockChoiceFiltered.length > 0) {
          mockGrad = mockChoiceFiltered[0].grad
        }
        mockTab1Table1ItemRows.push({
          numitem: e,
          definit: 'Sub description',
          desitem: 'description555 ',
          qtyfscor: mockItemQtyfscor,
          qtyscor: mockItemQtyscor,
          graditem: mockItemGraditem,
          grad: mockGrad,
          qtywgt: mockItemQtywgt,
          flgdqtysc: '',
          choices: mockTab1Table2Rows
        })
        mockGroupQtyfscor += mockItemQtyfscor
        mockGroupQtyscor += mockItemQtyscor
      }
      mockTab1Table1GroupRows.push({
        numgrup: a,
        desc_numgrup: 'หัวข้อเรื่อง',
        qtyfscor: mockGroupQtyfscor,
        qtyscor: mockGroupQtyscor,
        desimpro: faker.random.words(),
        numitem: mockTab1Table1ItemRows
      })
    }

    let mockTab2 = {
      dteapman: moment(faker.date.past()).format('DD/MM/YYYY'),
      dteapstr: moment(faker.date.past()).format('DD/MM/YYYY'),
      dteapend: moment(faker.date.past()).format('DD/MM/YYYY'),
      codpos: faker.random.words(),
      nampos: faker.random.words(),
      codjob: faker.random.words(),
      namjob: faker.random.words(),
      commboss: faker.random.words(),
      commemp: faker.random.words()
    }
    let mockTab2Table1GroupRows = []
    const mockDescNumitem = [ 'ภาษาอังกฤษ', 'ภาษาจีน', 'ภาษาเยอรมัน', 'ภาษาฝรั่งเศษ' ]
    const mockTab2Table1Total = 1
    for (var m = 1; m <= mockTab2Table1Total; m++) {
      let mockTab2Table1ItemRows = []
      const mockTab2Table1ItemTotal = 4
      let mockGroupQtyfscor = 0
      let mockGroupQtyscor = 0
      for (var n = 1; n <= mockTab2Table1ItemTotal; n++) {
        let mockItemQtywgt = Math.floor(Math.random() * 0) + 1
        let mockItemQtyfscor = 4 * mockItemQtywgt
        let mockItemGraditem = Math.floor(mockItemQtyfscor * Math.random())
        let mockItemQtyscor = mockItemGraditem * mockItemQtywgt
        let mockGapScore = Math.floor(Math.random() * 2) + 1
        let mockTab2Table2Rows = []
        const mockChoice2 = [ 'A', 'B', 'C', 'D' ]
        const mockDescChoice2 = [ 'Excellence', 'Good', 'Normal', 'Bad' ]
        const mockScore2 = [ '4', '3', '2', '1' ]
        const mockTab2Table2Total = 4
        for (var k = 1; k <= mockTab2Table2Total; k++) {
          mockTab2Table2Rows.push({
            grditem: k,
            grad: mockChoice2[k - 1],
            namgrad: mockDescChoice2[k - 1],
            desnote: faker.random.words(),
            score: mockScore2[k - 1]
          })
        }
        let mockChoice2Filtered = mockTab2Table2Rows.filter((choice) => {
          return choice.grditem === mockItemGraditem
        })
        let mockGrad = ''
        if (mockChoice2Filtered.length > 0) {
          mockGrad = mockChoice2Filtered[0].grad
        }
        mockTab2Table1ItemRows.push({
          numitem: 'L00' + n,
          desc_numitem: mockDescNumitem[n - 1],
          definit: 'ทดสอบใส่คำจำกัดความ',
          qtyfscor: mockItemQtyfscor,
          score: mockItemQtyscor,
          targetscore: Math.floor(Math.random() * 4) + 1,
          gapscore: mockGapScore,
          graditem: mockItemGraditem,
          grad: mockGrad,
          choices: mockTab2Table2Rows
        })
        mockGroupQtyfscor += mockItemQtyfscor
        mockGroupQtyscor += mockItemQtyscor
      }
      mockTab2Table1GroupRows.push({
        numgrup: '00' + m,
        desc_numgrup: 'ความสามารถด้านภาษา',
        qtyfscor: mockGroupQtyfscor,
        qtyscor: mockGroupQtyscor,
        desimpro: faker.random.words(),
        numitem: mockTab2Table1ItemRows
      })
    }

    let mockTab3Table1GroupRows = []
    let mockSumscor = 0
    let mockSumavg = 0
    const mockTab3Table1Total = 3
    for (var y = 1; y <= mockTab3Table1Total; y++) {
      let mockKpiwgt = Math.floor(Math.random() * 5) + 1
      let mockQtyscor = Math.floor(Math.random() * 10) + 1
      mockTab3Table1GroupRows.push({
        kpino: y,
        kpiitem: 'description',
        desc_status: 'ระหว่างดำเนินการ',
        kpiwgt: mockKpiwgt,
        qtyscor: mockQtyscor,
        avgscor: (mockQtyscor / mockKpiwgt).toString().substr(0, 4)
      })
      mockSumscor += mockQtyscor
      mockSumavg += mockQtyscor / mockKpiwgt
    }
    let mockTab3Table1Detail = {
      dteapman: moment(faker.date.past()).format('DD/MM/YYYY'),
      dteapstr: moment(faker.date.past()).format('DD/MM/YYYY'),
      dteapend: moment(faker.date.past()).format('DD/MM/YYYY'),
      sumscor: mockSumscor,
      sumavg: mockSumavg.toString().substr(0, 4),
      qtyscorcp: '100',
      avgscor: '0.00',
      sumscrnet: mockSumscor,
      sumavgnet: mockSumavg.toString().substr(0, 4),
      codcomp: 'TJS',
      desc_codcomp: faker.company.companyName()
    }

    return {
      tab1: {
        detail: mockTab1,
        table: {
          total: mockTab1Table1Total,
          rows: mockTab1Table1GroupRows
        }
      },
      tab2: {
        detail: mockTab2,
        table: {
          total: mockTab2Table1Total,
          rows: mockTab2Table1GroupRows
        }
      },
      tab3: {
        detail: mockTab3Table1Detail,
        table: {
          total: mockTab3Table1Total,
          rows: mockTab3Table1GroupRows
        }
      }
    }
  },
  detailTab1Desc2 () {
    let mockDetailTab1Desc2Rows = []
    const mockDetailTab1Desc2Total = 3
    for (let i = 1; i <= mockDetailTab1Desc2Total; i++) {
      let mockTab1Table1GroupRows = []
      const mockTab1Table1Total = 1
      for (var a = 1; a <= mockTab1Table1Total; a++) {
        let mockTab1Table1ItemRows = []
        const mockTab1Table1ItemTotal = 3
        let mockGroupQtyfscor = 0
        let mockGroupQtyscor = 0
        for (var e = 1; e <= mockTab1Table1ItemTotal; e++) {
          let mockItemQtywgt = Math.floor(Math.random() * 5) + 1
          let mockItemQtyfscor = 4 * mockItemQtywgt
          let mockItemGraditem = Math.floor(mockItemQtyfscor * Math.random())
          let mockItemQtyscor = mockItemGraditem * mockItemQtywgt
          let mockTab1Table2Rows = []
          const mockChoice = [ 'A', 'B', 'C', 'D' ]
          const mockDescChoice = [ 'Excellence', 'Good', 'Normal', 'Bad' ]
          const mockScore = [ '4', '3', '2', '1' ]
          const mockTab1Table2Total = 4
          for (var d = 1; d <= mockTab1Table2Total; d++) {
            mockTab1Table2Rows.push({
              grditem: d,
              grad: mockChoice[d - 1],
              qtyscor: mockScore[d - 1],
              desc_grditem: mockDescChoice[d - 1],
              definit: faker.random.words()
            })
          }
          let mockChoiceFiltered = mockTab1Table2Rows.filter((choice) => {
            return choice.grditem === mockItemGraditem
          })
          let mockGrad = ''
          if (mockChoiceFiltered.length > 0) {
            mockGrad = mockChoiceFiltered[0].grad
          }
          mockTab1Table1ItemRows.push({
            numitem: e,
            definit: 'Sub description',
            desitem: 'description ',
            qtyfscor: mockItemQtyfscor,
            qtyscor: mockItemQtyscor,
            graditem: mockItemGraditem,
            grad: mockGrad,
            qtywgt: mockItemQtywgt,
            flgdqtysc: '',
            choices: mockTab1Table2Rows
          })
          mockGroupQtyfscor += mockItemQtyfscor
          mockGroupQtyscor += mockItemQtyscor
        }
        mockTab1Table1GroupRows.push({
          numgrup: a,
          desc_numgrup: 'หัวข้อเรื่อง',
          qtyfscor: mockGroupQtyfscor,
          qtyscor: mockGroupQtyscor,
          desimpro: faker.random.words(),
          numitem: mockTab1Table1ItemRows
        })
      }
      mockDetailTab1Desc2Rows.push({
        numseq: i,
        dteapman: moment(faker.date.past()).format('DD/MM/YYYY'),
        dteapstr: moment(faker.date.past()).format('DD/MM/YYYY'),
        dteapend: moment(faker.date.past()).format('DD/MM/YYYY'),
        codform: faker.random.word(),
        desform: faker.random.words(),
        commboss: faker.random.words(),
        commemp: faker.random.words(),
        dteyreap: '2016',
        numtime: '1',
        codappr: faker.lorem.word(),
        desc_codappr: faker.name.findName(),
        v_qtydabs: Math.floor(Math.random() * 1) + 1,
        v_qtydleav: Math.floor(Math.random() * 1) + 1,
        v_qtydpun: Math.floor(Math.random() * 1) + 1,
        table: mockTab1Table1GroupRows
      })
    }

    return {
      total: mockDetailTab1Desc2Total,
      rows: mockDetailTab1Desc2Rows
    }
  },
  detailTab2Desc2 () {
    let mockDetailTab2Desc2Rows = []
    const mockDetailTab2Desc2Total = 3
    for (let i = 1; i <= mockDetailTab2Desc2Total; i++) {
      let mockTab2Table1GroupRows = []
      const mockDescNumitem = [ 'ภาษาอังกฤษ', 'ภาษาจีน', 'ภาษาเยอรมัน', 'ภาษาฝรั่งเศษ' ]
      const mockTab2Table1Total = 1
      for (var m = 1; m <= mockTab2Table1Total; m++) {
        let mockTab2Table1ItemRows = []
        const mockTab2Table1ItemTotal = 4
        let mockGroupQtyfscor = 0
        let mockGroupQtyscor = 0
        for (var n = 1; n <= mockTab2Table1ItemTotal; n++) {
          let mockItemQtywgt = Math.floor(Math.random() * 0) + 1
          let mockItemQtyfscor = 4 * mockItemQtywgt
          let mockItemGraditem = Math.floor(mockItemQtyfscor * Math.random())
          let mockItemQtyscor = mockItemGraditem * mockItemQtywgt
          let mockGapScore = Math.floor(Math.random() * 2) + 1
          let mockTab2Table2Rows = []
          const mockChoice2 = [ 'A', 'B', 'C', 'D' ]
          const mockDescChoice2 = [ 'Excellence', 'Good', 'Normal', 'Bad' ]
          const mockScore2 = [ '4', '3', '2', '1' ]
          const mockTab2Table2Total = 4
          for (var k = 1; k <= mockTab2Table2Total; k++) {
            mockTab2Table2Rows.push({
              grditem: k,
              grad: mockChoice2[k - 1],
              namgrad: mockDescChoice2[k - 1],
              desnote: faker.random.words(),
              score: mockScore2[k - 1]
            })
          }
          let mockChoice2Filtered = mockTab2Table2Rows.filter((choice) => {
            return choice.grditem === mockItemGraditem
          })
          let mockGrad = ''
          if (mockChoice2Filtered.length > 0) {
            mockGrad = mockChoice2Filtered[0].grad
          }
          mockTab2Table1ItemRows.push({
            numitem: 'L00' + n,
            desc_numitem: mockDescNumitem[n - 1],
            definit: 'ทดสอบใส่คำจำกัดความ',
            qtyfscor: mockItemQtyfscor,
            score: mockItemQtyscor,
            targetscore: Math.floor(Math.random() * 4) + 1,
            gapscore: mockGapScore,
            graditem: mockItemGraditem,
            grad: mockGrad,
            choices: mockTab2Table2Rows
          })
          mockGroupQtyfscor += mockItemQtyfscor
          mockGroupQtyscor += mockItemQtyscor
        }
        mockTab2Table1GroupRows.push({
          numgrup: '00' + m,
          desc_numgrup: 'ความสามารถด้านภาษา',
          qtyfscor: mockGroupQtyfscor,
          qtyscor: mockGroupQtyscor,
          desimpro: faker.random.words(),
          numitem: mockTab2Table1ItemRows
        })
      }
      mockDetailTab2Desc2Rows.push({
        numseq: i,
        dteapman: moment(faker.date.past()).format('DD/MM/YYYY'),
        dteapstr: moment(faker.date.past()).format('DD/MM/YYYY'),
        dteapend: moment(faker.date.past()).format('DD/MM/YYYY'),
        codpos: faker.random.words(),
        nampos: faker.random.words(),
        codjob: faker.random.words(),
        namjob: faker.random.words(),
        commboss: faker.random.words(),
        commemp: faker.random.words(),
        dteyreap: '2016',
        numtime: '1',
        codappr: faker.lorem.word(),
        desc_codappr: faker.name.findName(),
        table: mockTab2Table1GroupRows
      })
    }

    return {
      total: mockDetailTab2Desc2Total,
      rows: mockDetailTab2Desc2Rows
    }
  },
  detailTab3Desc1 () {
    let mockDetailTab3Desc1Rows = []
    const mockDetailTab3Desc1Total = 3
    for (let i = 1; i <= mockDetailTab3Desc1Total; i++) {
      let mockTab3Table1GroupRows = []
      let mockSumscor = 0
      let mockSumavg = 0
      const mockTab3Table1Total = 3
      for (var y = 1; y <= mockTab3Table1Total; y++) {
        let mockKpiwgt = Math.floor(Math.random() * 5) + 1
        let mockQtyscor = Math.floor(Math.random() * 10) + 1
        mockTab3Table1GroupRows.push({
          kpino: y,
          kpiitem: 'description',
          desc_status: 'ระหว่างดำเนินการ',
          kpiwgt: mockKpiwgt,
          qtyscor: mockQtyscor,
          avgscor: (mockQtyscor / mockKpiwgt).toString().substr(0, 4)
        })
        mockSumscor += mockQtyscor
        mockSumavg += mockQtyscor / mockKpiwgt
      }
      mockDetailTab3Desc1Rows.push({
        numseq: i,
        dteapman: moment(faker.date.past()).format('DD/MM/YYYY'),
        dteapstr: moment(faker.date.past()).format('DD/MM/YYYY'),
        dteapend: moment(faker.date.past()).format('DD/MM/YYYY'),
        sumscor: mockSumscor,
        sumavg: mockSumavg.toString().substr(0, 4),
        qtyscorcp: '100',
        avgscor: '0.00',
        sumscrnet: mockSumscor,
        sumavgnet: mockSumavg.toString().substr(0, 4),
        codcomp: 'TJS',
        desc_codcomp: faker.company.companyName(),
        dteyreap: '2016',
        numtime: '1',
        codappr: faker.lorem.word(),
        desc_codappr: faker.name.findName(),
        table: mockTab3Table1GroupRows
      })
    }

    return {
      total: mockDetailTab3Desc1Total,
      rows: mockDetailTab3Desc1Rows
    }
  },
  detailTab3Desc2 () {
    let mockTab3Table1GroupRows = []
    let mockSumscor = 0
    let mockSumavg = 0
    const mockTab3Table1Total = 3
    for (var y = 1; y <= mockTab3Table1Total; y++) {
      let mockKpiwgt = Math.floor(Math.random() * 5) + 1
      let mockQtyscor = Math.floor(Math.random() * 10) + 1
      mockTab3Table1GroupRows.push({
        kpino: y,
        kpiitem: 'description',
        desc_status: 'ระหว่างดำเนินการ',
        kpiwgt: mockKpiwgt,
        qtyscor: mockQtyscor,
        avgscor: (mockQtyscor / mockKpiwgt).toString().substr(0, 4)
      })
      mockSumscor += mockQtyscor
      mockSumavg += mockQtyscor / mockKpiwgt
    }
    let mockTab3Table1Detail = {
      dteyreap: '2015',
      numtime: '1',
      codappr: faker.lorem.word(),
      desc_codappr: faker.name.findName(),
      dteapman: moment(faker.date.past()).format('DD/MM/YYYY'),
      dteapstr: moment(faker.date.past()).format('DD/MM/YYYY'),
      dteapend: moment(faker.date.past()).format('DD/MM/YYYY'),
      sumscor: mockSumscor,
      sumavg: mockSumavg.toString().substr(0, 4),
      qtyscorcp: '100',
      avgscor: '0.00',
      sumscrnet: mockSumscor,
      sumavgnet: mockSumavg.toString().substr(0, 4),
      codcomp: 'TJS',
      desc_codcomp: faker.company.companyName()
    }

    return {
      detail: mockTab3Table1Detail,
      table: {
        total: mockTab3Table1Total,
        rows: mockTab3Table1GroupRows
      }
    }
  },
  detailTab3Desc3 () {
    let mockTab3TableDesc3Rows = []
    const mockTab3TableDesc3Total = 2
    for (let i = 1; i <= mockTab3TableDesc3Total; i++) {
      let mockTableDesc3Rows = []
      const mockTableDesc3Total = 2
      for (var q = 1; q <= mockTableDesc3Total; q++) {
        mockTableDesc3Rows.push({
          workno: q,
          workitem: faker.random.words(),
          workfin: faker.random.words()
        })
      }
      mockTab3TableDesc3Rows.push({
        dteyreap: moment().format('YYYY'),
        numtime: Math.floor(Math.random() * 3) + 1,
        kpino: i,
        desc_codcomp: faker.random.words(),
        kpiitem: faker.random.words(),
        target: faker.random.words(),
        mtrunit: 'ครั้ง/ปี',
        dtetarg: moment(faker.date.past()).format('DD/MM/YYYY'),
        mtrvalue: faker.commerce.price(),
        mtrfinish: faker.commerce.price(),
        kpiwgt: faker.random.number().toString().substr(0, 2),
        grdap: faker.random.number().toString().substr(0, 2),
        wgttot: faker.random.number().toString().substr(0, 2),
        tableDesc3: mockTableDesc3Rows
      })
    }

    return {
      total: mockTab3TableDesc3Total,
      rows: mockTab3TableDesc3Rows
    }
  },
  detail3Info () {
    let mockTab3DetailInfoRows = []
    const mockTab3DetailInfoTotal = 3
    for (let i = 1; i <= mockTab3DetailInfoTotal; i++) {
      let mockTab3TableInfoRows = []
      const mockTab3TableInfoTotal = 2
      for (var q = 1; q <= mockTab3TableInfoTotal; q++) {
        mockTab3TableInfoRows.push({
          kpino: i,
          workno: q,
          workitem: faker.random.words(),
          actbedon: faker.random.words()
        })
      }
      mockTab3DetailInfoRows.push({
        kpino: i,
        kpiitem: faker.random.words(),
        target: faker.random.words(),
        achieve: faker.random.words(),
        v_mtrunit: 'ครั้ง/ปี',
        mtrvalue: faker.commerce.price(),
        v_mtrvalue: faker.commerce.price(),
        status: Math.floor(Math.random() * 3) + 1,
        dtetargt: moment(faker.date.past()).format('DD/MM/YYYY'),
        kpiwgt: faker.random.number().toString().substr(0, 2),
        grdscor: faker.random.number().toString().substr(0, 2),
        table: mockTab3TableInfoRows
      })
    }

    return {
      total: mockTab3DetailInfoTotal,
      rows: mockTab3DetailInfoRows
    }
  },
  dropdowns () {
    const mockStatus = {
      '1': 'ยังไม่ดำเนินการ',
      '2': 'ระหว่างดำเนินการ',
      '3': 'เสร็จสมบูรณ์',
      '4': 'เลื่อนกำหนด'
    }

    const mockFlgdqtysc = {
      '1': 'ทำงานผิดปกติ',
      '2': 'ลา',
      '3': 'ผิดวินัย',
      '4': 'ทั้งหมด'
    }

    return {
      statuskpi: {
        en: mockStatus,
        th: mockStatus
      },
      flgdqtysc: {
        en: mockFlgdqtysc,
        th: mockFlgdqtysc
      }
    }
  },
  detailCourse () {
    let mockDetailCourseRows = []
    const mockDetailCourseTotal = 1
    for (var t = 1; t <= mockDetailCourseTotal; t++) {
      mockDetailCourseRows.push({
        codcours: faker.random.word(),
        desc_codcours: 'หลักสูตรกำจัดแมลง Level1',
        desc_codcate: 'Core Competency',
        desc_typtrain: 'ฝึกยกระดับฝีมือแรงงาน',
        qtyppc: faker.random.number().toString().substr(0, 2)
      })
    }

    return {
      total: mockDetailCourseTotal,
      rows: mockDetailCourseRows
    }
  },
  sumscore (param) {
    return {
      qtybeh: '10',
      avgbeh: '10.5',
      qtycmp: '20',
      avgcmp: '20.5',
      qtykpi: '30',
      avgkpi: '30.5'
    }
  },
  detailCourseAddInline (param) {
    return {
      codcours: faker.random.word(),
      desc_codcours: faker.random.words(),
      desc_codcate: faker.random.words(),
      desc_typtrain: faker.random.words(),
      qtyppc: faker.random.number().toString().substr(0, 2)
    }
  },
  popupCourseGap () {
    let mockDetail1Desc1PopupRows = []
    const mockGrade = [ 'A', 'B', 'C', 'D' ]
    const mockDetail1Desc1PopupTotal = 5
    for (var i = 1; i <= mockDetail1Desc1PopupTotal; i++) {
      mockDetail1Desc1PopupRows.push({
        id: i,
        codskill: faker.random.word(),
        desc_codskill: faker.random.words(),
        grade: mockGrade[i - 1],
        codcours: faker.random.word(),
        desc_codcours: faker.random.words(),
        desc_codcate: faker.random.words(),
        desc_typtrain: faker.random.words(),
        qtyppc: faker.random.number().toString().substr(0, 2)
      })
    }

    return {
      total: mockDetail1Desc1PopupTotal,
      rows: mockDetail1Desc1PopupRows
    }
  },

  popupDetail3InfoDesc2 () {
    let mockPopup = {
      dteyreap: moment().format('YYYY'),
      numtime: faker.random.number().toString().substr(0, 1),
      codempid: faker.lorem.word(),
      desc_codempid: faker.name.findName(),
      kpino: Math.floor(Math.random() * 2) + 1,
      kpiitem: faker.random.words(),
      target: faker.random.words(),
      v_mtrunit: 'หน่วย',
      mtrvalue: faker.commerce.price()
    }
    let mockDetail3Desc2PopupRows = []
    const mockDetail3Desc2PopupTotal = 5
    for (var w = 1; w <= mockDetail3Desc2PopupTotal; w++) {
      mockDetail3Desc2PopupRows.push({
        dteapkpi: moment(faker.date.past()).format('DD/MM/YYYY'),
        actbedon: 'Test',
        mtrvalue: faker.commerce.price(),
        mtrvalnet: faker.commerce.price()
      })
    }

    return {
      detail: mockPopup,
      table: {
        total: mockDetail3Desc2PopupTotal,
        rows: mockDetail3Desc2PopupRows
      }
    }
  },
  sendmail () {
    let mockSendmail = {}

    return mockSendmail
  },
  send () {
    return labels.mockPostMessage
  },
  save () {
    return labels.mockPostMessage
  },
  delete () {
    return labels.mockPostMessage
  }
}



// WEBPACK FOOTER //
// ./src/api/hrms15e/mocker.js